<ng-container *ngIf="dataSource?.CardData as ds">

    <article
        class="bg-white flex md:flex-col flex-row h-[190px] md:h-auto items-stretch rounded-2xl border border-solid shadow-sm overflow-hidden mb-3 w-full"
        [class]="dataSource?.Header ? 'light-blue-border' : ''">

        <div class="flex md:flex-col flex-row  md:items-stretch w-full relative">
            <div class="h-56  md:w-full w-[150px]  swiper-cards-search relative" 
            *ngIf="ds.Pictures.length">
                <swiper *ngIf="csrStatus() && !navigatorVal" (slideChange)="onSlideChange($event)"
                    [config]="swiperConfig" class="!h-56 max-h-56 min-h-56" #swiper>
                    <ng-template swiperSlide *ngFor="
                                 let item of ds.Pictures;
                                 let index = index;
                                 let last = last;
                                 let first = first">
                        <img *ngIf="item?.Jpg" [ngSrc]="item?.Jpg!" [loading]="first ? 'eager' : 'lazy'"
                            (error)="item.Jpg = cdnUrl + '/images/no-image.jpg'" class="h-full w-full object-cover"
                            height="230" width="250" [alt]="item.Alt" />
                        <img *ngIf="!item?.Jpg" [ngSrc]="cdnUrl + '/images/no-image.jpg'"
                            class="h-full w-full object-cover" height="230" width="250" [alt]="item.Alt" />
                    </ng-template>
                    <ng-template swiperSlide class="md:hidden">
                        <button *ngIf="ds.Pictures.length + 1" (click)="navigateToPDP(ds.HotelUrl, $event)"
                            class="flex md:hidden flex-col items-center justify-center h-[176px] w-full">
                            <i class="ico-LeftArrowCircle text-4xl text-blue"></i>
                            <span class="text-sm text-black font-semibold">مشاهده بیشتر</span>
                        </button>
                    </ng-template>
                </swiper>
                <img *ngIf="navigatorVal" [ngSrc]="ds.Pictures[0]?.Jpg!"
                    (error)="ds.Pictures[0].Jpg = cdnUrl + '/images/no-image.jpg'" class="h-full w-full object-cover"
                    height="230" width="250" [alt]="ds.Pictures[0].Alt" />
                <ng-container *ngIf="!navigatorVal">
                    <div class="swiper-button-prev flex" *ngIf="showArrowNext" (click)="nextSlide()">
                        <i class="ico-Left text-3xl"></i>
                    </div>
                    <div class="swiper-button-next flex" *ngIf="showArrowPrev" (click)="previousSlide()">
                        <i class="ico-Right text-3xl"></i>
                    </div>
                </ng-container>

            </div>
            <div *ngIf="!ds.Pictures.length"
                class="h-56 min-w-[12rem] w-full md:w-[300px] md:min-w-[320px] swiper-cards-search relative">
                <img [ngSrc]="cdnUrl + '/images/no-image.jpg'" class="h-full w-full object-cover" height="230" width="300" />
            </div>

            <!-- min-width of our card's image is 12rem + 1rem margin = 13rem -->

            <div
                class="card-content-wrapper flex flex-col w-[200px] md:w-auto items-stretch flex-grow justify-between p-2 md:p-4">
                <!-- residence info section -->
                <div class="flex flex-col  md:border-left w-full pb-2 md:pb-0 md:pl-4 bordered-section flex-grow">

                    <!-- [routerLink]="ds.HotelUrl"  [href]="ds.HotelUrl" -->
                    <!-- avatar and hotel's name -->

                    <div class="flex items-center lg:gap-2  max-w-full">
                        <img height="40" width="40" class="rounded-full border" alt="resident's owner avatar"
                            *ngIf="type !== 'hotel'" />
                        <!-- TODO: set titles and links -->
                        <a [href]="ds.HotelUrl" (click)="navigateToPDP(ds.HotelUrl, $event)">
                            <h2 class="text-black lg:text-base text-sm !font-semibold line-clamp-2" [title]="ds.FullName">
                                {{ ds.FullName }}
                            </h2>
                        </a>
                    </div>
                    <div class="flex flex-col lg:gap-2 gap-1">
                        <ng-container *ngIf="accommodation() && accommodation() == 'ecolodge';else noneStar">
                            <div class="flex items-center" *ngIf="ds.detailsRoom">
                                <i class="ico-Profile text-xl text-muted"></i>
                                <span class="text-muted text-sm truncate">{{ds.detailsRoom}}</span>
                            </div>
                        </ng-container>
                        <ng-template #noneStar>
                            <div class="flex items-center gap-2"
                                *ngIf="ds?.Star && type === 'hotel' && ds?.Star?.GradeId !== 0">
                                <i class="ico-Star-bold text-xl text-muted"></i>
                                <span class="text-muted text-sm">{{ ds?.Star?.GradeId }} ستاره</span>
                            </div>
                        
                        </ng-template>
                        <div class="flex items-center">
                            <i class="ico-Location-bold text-xl text-muted"></i>
                            <span class="text-muted text-sm"
                                *ngIf="accommodation() && accommodation() == 'ecolodge';else noneEcolodge"
                                [title]="ds?.Address?.Address">
                                {{
                                ds?.Address?.Address
                                }}</span>
                            <ng-template #noneEcolodge>
                                <span class="text-muted lg:text-sm text-xs line-clamp-1" [title]="ds?.Address?.Address">
                                    {{
                                    ds?.Address?.Address
                                    }}</span>

                            </ng-template>
                        </div>





                        <!-- rate and comments -->
                        <div class="flex items-center gap-2 justify-start">
                            <p class="text-blue-500 flex items-center gap-2">
                                <span class="h-7 w-7 text-center text-white text-base font-bold bg-blue-500"
                                    style="line-height: 1.75rem; border-radius: 4px">
                                    {{ ds?.Score?.ScoreNumber }}
                                </span>

                            </p>
                            <div>
                                <p class="score-text text-sm text-black-400">{{
                                    ds?.Score?.Text
                                    }}</p>

                                <p class="text-sm text-muted font-semibold" *ngIf="ds?.Score?.Total! > 0">{{
                                    ds?.Score?.Total + ' نظر'
                                    }}</p>
                            </div>

                        </div>
                        <button (click)="navigateToPDP(ds.HotelUrl, $event)"
                            class="bg-blue-500 min-w-[91px] lg:min-h-[36px] py-1 text-sm lg:text-base flex lg:hidden items-center justify-center rounded-lg text-white font-medium">رزرو
                            اتاق</button>

                    </div>


                </div>

                <!-- price and reserve button -->
                <div class="flex-col gap-2 md:h-full md:pr-4 justify-end w-full max-w-[250px] hidden lg:flex">
                    <ng-container *ngIf="!dataSource?.FullCapacity; else fullCapacityBtn">
                        <div *ngIf="ds.Price?.OldPrice && ds.Price.IhoPrice"
                            class="flex w-full items-center justify-end gap-2">
                            <span *ngIf="ds.Price?.BoardPrice != ds.Price?.IhoPrice"
                                class="price-off mx-2 after:content-[''] line-through-price text-black-200 text-xs !font-normal">{{
                                ds.Price?.BoardPrice | toToman | number : '2.' }}</span>
                            <div *ngIf="
                  ds?.DiscountBalloon?.Discount &&
                  +ds.DiscountBalloon.Discount! >= 5
                " class="badge-precent bg-green-50 px-3 py-1 rounded-lg">
                                <span class="text-sm text-green-800 !font-medium">{{ ds?.DiscountBalloon?.Discount
                                    }}%</span>
                            </div>
                        </div>

                        <div *ngIf="ds.Price.IhoPrice" class="flex w-full items-center gap-1 justify-end">
                            <span class="text-xs text-muted">{{
                                ds?.Price?.StartingText
                                }}</span>
                            <span class="text-black-500 text-xl font-bold">{{
                                ds?.Price?.IhoPrice | toToman | number : '2.'
                                }}</span>
                            <span class="text-xs text-muted">تومان</span>
                        </div>


                    </ng-container>

                    <ng-template #fullCapacityBtn>
                        <div *ngIf="ds.Price?.OldPrice && ds.Price.IhoPrice"
                            class="flex w-full items-center justify-end gap-2">
                            <span
                                class="price-off mx-2 after:content-[''] text-black-200 line-through-price text-xs !font-normal">{{
                                ds.Price?.BoardPrice | toToman | number : '2.' }}</span>
                            <div class="badge-precent bg-green-50 px-3 py-1 rounded-lg">
                                <span class="text-sm text-green-800 !font-medium">{{ ds?.DiscountBalloon?.Discount
                                    }}%</span>
                            </div>
                        </div>

                        <div class="flex w-full items-center gap-1 justify-end">
                            <span class="text-xs text-muted">{{
                                ds?.Price?.StartingText
                                }}</span>
                            <span class="text-black-500 text-xl font-bold">{{
                                ds?.Price?.IhoPrice | toToman | number : '2.'
                                }}</span>
                            <span class="text-xs text-muted">تومان</span>
                        </div>

                        <button mat-stroked-button color="warn"
                            class="flex icon-button w-full !h-11 items-center justify-center font-semibold gap-2 text-red-500">
                            <i class="ico-LeftOver text-2xl text-red-500"></i>
                            <span class="text-base text-red-500">تکمیل ظرفیت</span>
                        </button>
                    </ng-template>

                </div>
            </div>
        </div>


    </article>
</ng-container>